import * as React from 'react';

export interface FooterProps {
  /** Any element to be rendered inside under title */
  children?: React.ReactNode;
  /** Define styles through a classname */
  className?: string;
  /** Show divider */
  showDivider?: boolean;
  /** Remove paddings from the footer */
  noPadding?: boolean;
}
